import React, { useState } from 'react'
import { Divider, Layout, Menu } from 'antd';
import '../../style/component.css'
import {routes} from './SidebarMenuRoute';
import { Link, NavLink, useLocation } from 'react-router-dom';

const { Sider } = Layout;


function AdminSidebarMenu() {

    const location = useLocation();
    const [openKeys, setOpenKeys] = useState([]);

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    };

    const findSelectedKey = (path) => {
        for (const route of routes) {
            if (route.path === path) return route.key;
            if (route.children) {
                for (const subRoute of route.children) {
                    if (subRoute.path === path) return subRoute.key;
                }
            }
        }
        return '';
    };

    const selectedKey = findSelectedKey(location.pathname);

    return (
        <Sider
            className='sidebar'
            width={240}
            theme="light"
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {
                console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
                console.log(collapsed, type);
            }}
        >
            <Menu
                theme="light"
                mode="inline"
                defaultSelectedKeys={[selectedKey]}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
            >
                {routes.map((route, index) => {
                    if (route.children) {
                        return (
                            <Menu.SubMenu
                                key={route.key}
                                title={<span className="menu_item">{route.label}</span>}
                                icon={<span className="side_menu_icon">{route.icons}</span>}
                            >
                                {route.children.map((subRoute, subIndex) => (
                                    <Menu.Item
                                        key={subRoute.key}
                                        icon={<span className="side_menu_icon">{subRoute.icons}</span>}
                                    >
                                        <NavLink to={subRoute.path} >{subRoute.label}</NavLink>
                                    </Menu.Item>
                                ))}
                            </Menu.SubMenu>
                        );
                    }
                    return (
                        <>
                            {route.type === "group" ? <Menu.Item
                                key={route.key}
                            >
                                <div>
                                    <span className='group_label'>{route.label}</span>
                                </div>
                            </Menu.Item> :
                                <Menu.Item
                                    key={route.key}
                                    icon={<span className="side_menu_icon">{route.icons}</span>}

                                >
                                    <NavLink to={route.path}>
                                        <span className='menu_item'> {route.label}</span>
                                    </NavLink>

                                </Menu.Item>}
                        </>
                    );
                })}
                <Divider />
            </Menu>
        </Sider>
    )
}

export default AdminSidebarMenu

